/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ChiefComplaintsApi } from '../api/chiefcomplaint.api';
import { switchMap, map } from 'rxjs/operators';
import { ChiefComplaintsData, ChiefComplaints } from '../../../interfaces/masters/chiefcomplaint';

@Injectable()
export class ChiefComplaintsService extends ChiefComplaintsData {

  constructor(private api: ChiefComplaintsApi) {
    super();
  }


  list(url: string): Observable<ChiefComplaints[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ChiefComplaints>{
      return this.api.getById(url);
  }

  create(url: string, data:ChiefComplaints): Observable<ChiefComplaints[]> {
    return this.api.add(url,data);
  }

  createChiefCompMasterDtl(url: string, data:any): Observable<any[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:ChiefComplaints): Observable<ChiefComplaints> {
    return this.api.update(url,data);
  }

  updateChiefCompMasterDtl(url: string, data:any): Observable<any> {
    return this.api.updateChiefCompMasterDtl(url,data);
  }


  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
